import DuckEntity from './DuckEntity';

const entity = new DuckEntity('customerInfos');

export { entity };
